<template>
  <div class='classDetail'>
    <!-- 详情顶部 -->
    <div class="detail-header w">
      <div class="fbox fbox-w">
        <img class="picture" :src="info.img">
        <div class="detail-header-right fg1">
          <div>
            <!-- 标题 -->
            <div class="title fbox fbox-ac">
              <p class="title-lable tc fsh m-r-5" v-if="info.preinstallMajor">{{info.preinstallMajor.short}}</p>
              <p class="fg1 color-black f24 font-weight-b ell">{{info.name}}</p>
            </div>
            <!-- 简介 -->
            <div class="synopsis f16 color-gray" >
              {{info.introduction}}
            </div>
          </div>
          <!-- 老师 -->
          <div class="teacherList fbox  fbox-w">
            <div class="teacher tc" v-for="(teacher, i) in teacherList" :key="i" >
              <tk-avatar>
                <tk-image :src="teacher.headPortrait" width="100" height="100"></tk-image>
              </tk-avatar>
              <p class="tc f16 color-gray">{{teacher.nickname}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btn-box fbox fbox-ac fbox-jb fbox-w">
        <div class="fg1 fbox fbox-ac" style="minWidth: 150px">
          <tk-icon class="fsh m-r-5" color="#8e9299" >jihe</tk-icon>
          <!-- <p class="fg1 f16 color-gray">共{{info.num || 0}}节课</p> -->
          <p class="fg1 f16 color-gray">共{{info.preinstallNum || 0}}个课时</p>
        </div>
        <div class="btn-contener fsh fbox fbox-jb">
          <div class="join" @click="joinCourse()">
            加入选课
          </div>
          <div class="get" @click="getOrder()">
            立即获取
          </div>
        </div>

      </div>
      <!-- 分割线 -->
      <div class="cut-off-rule"></div>
      <!-- 课程说明 -->
      <div class="explain fbox fbox-ac fbox-w">
        <div class="explain-left fbox fbox-ac fbox-w m-r-15">
          <div class=" fbox fbox-ac" v-for="(item, index) in labelList" :key="index">
            <img style="width:20px;height:19.5px;" src="https://qingbo-oss.oss-cn-beijing.aliyuncs.com/08f49dce-5404-4e97-9143-f9c658a9976c.png">
            <p class="color-black f16 ml10 fsh">{{item.name}}</p>
          </div>
        </div>
        <div class="vertical-line"></div>
        <div class="explain-right fbox fbox-ac fbox-w m-l-15">
          <p class="color-gray f16 fsh">使用软件：</p>
          <img v-for="(item, index) in softwareList" :key='index' :src="item.image">
        </div>
      </div>
    </div>
    <!-- 课程列表 -->
    <div class="title-tab f16 color-black w fbox fbox-ac fbox-ja">
      <div @click="tab(1)" :class="{active: tabIndex === 1}">专业介绍</div>
      <div class="ai" @click="tab(2)" :class="{active: tabIndex === 2}">
        课程目录
        <p>免费试看</p>
      </div>
    </div>
    <div class="course-container w" v-if="tabIndex === 1">
      <div v-html="info.introduce"></div>
    </div>
    <div class="course-container w" v-if="tabIndex === 2">
      <courseCatalogue :chapterArr='chapterArr' :kernelArr='kernelArr' />
    </div>
  </div>
</template>

<script>
import courseCatalogue from '@/components/courseCatalogue'

export default {
  name: 'classDetail',
  components: {
    courseCatalogue
  },
  data () {
    return {
      id: '',
      info: {},
      tabIndex: 1,
      teacherList: [
      ],
      softwareList: [],
      labelList: [],
      courseList: [],
      curriculaVariable: [],
      chapterArr: [],
      kernelArr: {}
    }
  },
  mounted () {
    this.id = this.$route.query.id
    this.init()
  },
  methods: {
    async init () {
      await this.getInfo()
    },
    async getUserCourse () {
      // 个人的课程
      let res = await this.$tkParse.getData(`/classes/_User/${this.$store.state.user.objectId}`)
      this.curriculaVariable = res.curriculaVariable || []
    },
    // 获取详情
    async getInfo () {
      let res = await this.$tkParse.getData(`/classes/course/${this.id}`, {
        params: { // url参数
          include: 'preinstallMajor' // 如果有多个关联都需要查询，用英文逗号分隔,例如：'pointer1,pointer2'
        }
      })
      // console.log(res)
      this.info = res
      if (this.info.introduce) {
        this.info.introduce = this.richText(this.info.introduce)
      }
      // 老师详情
      if (res.teacher) { await this.getTeacher() }
      // 软件详情
      if (res.software) { await this.getSemester() }
      // 标签详情
      if (res.label) { await this.getLabel() }
      if (res.chapter) {
        let chapterArr = await this.$tkParse.post('/web/getAllChapter', res.chapter) // 请求云代码
        this.chapterArr = chapterArr.data
        let kernelIdArr = []
        chapterArr.data.forEach(item => {
          kernelIdArr = kernelIdArr.concat(item.course)
        })
        kernelIdArr = [...new Set(kernelIdArr)] // 去重
        let kernelArr = await this.$tkParse.post('/web/getAllKnobble', kernelIdArr) // 请求云代码
        this.kernelArr = kernelArr.data
      }
    },
    // 获取老师详细信息
    async getTeacher () {
      let teacherList = []
      for (let index = 0; index < this.info.teacher.length; index++) {
        let res = await this.$tkParse.getData(`/classes/_User/${this.info.teacher[index]}`)
        teacherList.push(res)
      }
      this.teacherList = teacherList
    },
    // 获取老师详细信息
    async getSemester () {
      let softwareList = []
      this.info.software.forEach(async (item, index) => {
        let res = await this.$tkParse.getData(`/classes/software/${item}`)
        softwareList.push(res)
      })
      this.softwareList = softwareList
    },
    // 获取标签详情
    async getLabel () {
      let labelList = []
      this.info.label.forEach(async (item, index) => {
        let res = await this.$tkParse.getData(`/classes/label/${item}`)
        labelList.push(res)
      })
      this.labelList = labelList
    },
    // 立即获取
    async getOrder () {
      if (this.$login(this)) { return }
      let type = '1'
      let setData = []
      let obj = {
        addType: type,
        id: this.info.objectId
      }
      setData.push(obj)
      sessionStorage.setItem('order', JSON.stringify(setData))
      this.$push('/ordersSubmit')
    },
    // 加入选课
    async joinCourse (parameter) {
      if (this.$login(this)) { }
      // type区分合集和课程
      let type = '1'
      let id = this.info.objectId
      if (parameter) { id = parameter }
      let res = await this.$tkParse.getList('/classes/registrationCenter', {
        params: {
          where: {
            user: this.$store.state.user.objectId
          }
        }
      })
      if (res.length) {
        let idArr = []
        let putData = res[0].course
        res[0].course.forEach(item => {
          idArr.push(item.id)
        })
        if (idArr.indexOf(this.info.objectId) !== -1) {
          this.$Message.warning({ content: '请勿重复添加' })
          return
        }
        putData.push({ type, id })
        let put = await this.$tkParse.put(`/classes/registrationCenter/${res[0].objectId}`, {
          course: putData
        })
        if (put) {
          this.$Message.success('添加成功')
          this.$store.commit('setCarNum', this.$store.state.carNum + 1)
        } else {
          this.$Message.error('添加失败')
        }
        return
      }

      let postData = {
        user: this.$store.state.user.objectId,
        course: [
          { type, id }
        ]
      }
      let post = await this.$tkParse.post('/classes/registrationCenter', postData)
      if (post) {
        this.$Message.success('添加成功')
        this.$store.commit('setCarNum', this.$store.state.carNum + 1)
      } else {
        this.$Message.error('添加失败')
      }
    },
    toCourseDetail (id) {
      this.$push({
        path: '/classDetail',
        query: {
          id: id
        }
      })
    },
    // 切换tab导航
    tab (index) {
      this.tabIndex = index
    },
    // 富文本过滤图片样式
    richText (content) {
      content = content.replace(/style="[^"]*?"/g, '')
      content = content.replace(/height="[^"]*?"/g, '')
      content = content.replace(/width="[^"]*?"/g, '')
      content = content.replace(/img/g, 'img width="100%" ')
      return content
    }
  }
}
</script>
<style lang="scss" scoped>
.classDetail{
  background-color: #F5F5F8;
  padding: 20px 0 70px;
  .detail-header{
    padding: 40px;
    box-sizing: border-box;
    background: #FFFFFF;
    .picture{
      width: 360px;
      height: 240px;
      border: 1px solid #707070;
    }
    .detail-header-right{
      min-width: 250px;
      margin-left: 45px;
    }
    .title{
      width: 100%;
      .title-lable{
        display: inline-block;
        width: 42px;
        height: 26px;
        line-height: 26px;
        background: #DCAF80;
        border-radius: 4px;
        font-size: 16px;
        color: #ffffff;
        font-weight: 400;
      }
    }
    .synopsis{
      margin-top: 10px;
      img{
        width: 29px;
        height: 29px;
        margin-right: 5px;
      }
      div{
        height: 50px;
      }
    }
    .teacherList{
      margin: 30px 0 20px;
      width: 100%;
      // overflow-x: scroll;
      .teacher{
        margin-right: 30px;
        img{
          width: 55px;
          height: 55px;
          border-radius: 50%;
        }
      }
    }
    .cut-off-rule{
      width: 100%;
      height: 0px;
      border-top: 1px solid #EBEBEB;
    }
    .btn-box{
      // height: 100px;
      padding: 0 0 20px 0;

      .btn-contener{
        width: 360px;
        div{
          width: 160px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 18px;
          border-radius: 4px;
          cursor: pointer;
        }
        .join{
          border: 1px solid #EA3553;
          color: #EA3553;
        }
        .get{
          background: #EA3553;
          color: #FFFFFF;
        }
      }
    }
    .explain{
      // height: 100px;
      padding-top: 20px;
      .vertical-line{
        width: 0px;
        height: 21px;
        border-left: 1px solid #EBEBEB;
        // margin: 0 38px;
      }
      .explain-left{
        div{
          margin: 0 20px 0 10px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .explain-right{
        img{
          margin: 0 10px 0 5px;
          width: 32px;
          height: 32px;
        }
      }
    }
  }

  .title-tab{
    padding: 0 20vw;
    height: 88px;
    background: #FFFFFF;
    margin-top: 20px !important;
    div{
      height: 88px;
      line-height: 88px;
      display: inline-block;
      // margin: 0 100px;
      position: relative;
      cursor: pointer;
      &:hover{
        color: #28B28B;
      }
      p{
        width: 66px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background: linear-gradient(243deg, #FC7559 0%, #EA3753 100%);
        border-radius: 12px 12px 12px 0px;
        font-size: 13px;
        color: #FFFFFF;
        position: absolute;
        top: 35%;
        right: -66px;
        transform: translateY(-50%);
      }
    }
    .active{
      color: #28B28B;
      font-weight: bold;
      position: relative;
      &::after{
        content: "";
        width: 100%;
        height: 0;
        border-bottom: 4px solid #28B28B;
        position: absolute;
        bottom: 0px;
        left: 0;
      }
    }
  }
}
.ai-container{
  background-color: #FFEDC2;
  padding: 0px 0 320px;
  .ai-container-item{
    padding: 86px 0 0px;
  }
}
.course-container{
  background-color: #fff;
  padding: 28px 40px;
  box-sizing: border-box;
}
@media(max-width: 992px) {
  #video{
    width:100%;
  }
  .detail-header{
    padding: 20px !important;
  }
  .detail-header-right{
    margin-left: 0 !important;
  }
  .picture{
    width: 100% !important;
  }
  .btn-contener{
    width: 100%  !important;
    margin-top: 10px;
    div{
      width: 45% !important;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 18px;
      border-radius: 4px;
      cursor: pointer;
    }
    .join{
      border: 1px solid #EA3553;
      color: #EA3553;
    }
    .get{
      background: #EA3553;
      color: #FFFFFF;
    }
  }
  .detail-header-right{
    min-width: 100px !important;
  }
  .teacherList {
    margin: 0px 0 10px !important;
  }
  .course-container{
    padding: 15px 20px;
  }
  .synopsis{
    margin-bottom: 10px;
  }
  .vertical-line{
    display: none;
  }
  .explain-right,.explain-left{
    margin-bottom: 10px;
  }
}
</style>
